import { createSlice } from "@reduxjs/toolkit";

const initialState = {

   propertiesMenu: {
      name: localStorage.getItem("token") ? "MyProperties" : "AllProperties",
      isPublic:localStorage.getItem("token") ? false : true,
   }
};

const navbarSlice = createSlice({
   name: "navbarSlice",
   initialState,
   reducers: {
      setPropertiesMenu: (state, { payload }) => {

         state.propertiesMenu.name = payload?.name
         state.propertiesMenu.isPublic = payload?.isPublic
      }
   },
})


export const { setPropertiesMenu } = navbarSlice.actions;

export default navbarSlice.reducer
